import { connect } from 'react-redux';
import MainNavComponent from '../components/main_nav';
import ConversationActions from '../actions/conversation';
import ConversationCreatorActions from '../actions/conversation_creator';
import ConversationDetailsActions from '../actions/conversation_details';

function mapStateToProps(state) {
  const users = state.activeConversation.id
    ? state.activeConversation.participants.map(participant => {
        return participant.user;
      })
    : [];

  return {
    hasActiveConversation: state.activeConversation.hasOwnProperty('id'),
    conversation: state.activeConversation,
    users: users,
    newConversation: state.conversationCreator.visible,
    conversationDetailsVisible: state.conversationDetails.visible
  };
}

const MainNavContainer = connect(
  mapStateToProps,
  {
    allConversations: ConversationActions.selectUnload,
    closeConversationCreator: ConversationCreatorActions.close,
    closeConversationDetails: ConversationDetailsActions.close,
    openConversationDetails: ConversationDetailsActions.open
  }
)(MainNavComponent);

export default MainNavContainer;
